import React, { useContext, useEffect, useState } from 'react';

import { Box } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useSession } from 'next-auth/react';

import AccountOrders from '../components/AccountOrders';
import ProgressMenu from '../components/ProgressMenu';
import ReservationDetailsDesktop from '../components/ReservationDetailsDesktop';
import ReservationDetailsTab from '../components/ReservationDetailsTab';
import BasicLayout from '../components/shared/BasicLayout';
import { track } from '../modules/segment';
import ReservationContext from '../providers/ReservationContext';

dayjs.extend(utc);
dayjs.extend(timezone);

const DashboardHome = () => {
  const { data: session } = useSession();
  const { orderV2Data } = useContext(ReservationContext);

  const { id: orderId, confirmation_id: confirmationId } = orderV2Data ?? {};

  const [paymentMethodCheck, setPaymentMethodCheck] = useState(false);

  useEffect(() => {
    if (orderId && confirmationId && !orderV2Data.payment_methods?.length && !paymentMethodCheck) {
      setPaymentMethodCheck(true);
      track('Dashboard - Payment Method missing', {
        orderId,
        confirmationId,
        partnerId: orderV2Data.partner_id,
      });
    }
  }, [orderId, confirmationId]);

  return (
    <BasicLayout>
      {session?.type === 'oauth' && !session?.reservationID ? (
        <AccountOrders />
      ) : (
        <Box
          sx={{
            height: '100%',
            minHeight: 'calc(100vh - 92px)',
            backgroundImage: 'linear-gradient(360deg, rgba(155, 184, 248, 0.25), 0%, rgba(205, 219, 251, 0.25) 100%)',
            pb: 10,
          }}
        >
          <Box sx={{ maxWidth: '924px', margin: '0 auto' }}>
            {session?.reservationID && orderId ? (
              <>
                <ReservationDetailsTab />
                <ReservationDetailsDesktop />
                <ProgressMenu />
              </>
            ) : null}
          </Box>
        </Box>
      )}
    </BasicLayout>
  );
};

export default DashboardHome;
